<template>
  <div class="organisations-grid">
    <div v-for="i in 4" :key="i" class="card skeleton-card">
      <div class="card-header skeleton-header">
        <div class="skeleton-line skeleton-title" />
      </div>
      <div class="card-content p-0">
        <ul class="stakeholder-list">
          <li v-for="j in 3" :key="j" class="stakeholder-item">
            <div class="skeleton-avatar" />
            <div class="stakeholder-info">
              <div class="stakeholder-top">
                <div class="skeleton-line skeleton-role" />
                <div class="skeleton-line skeleton-name" />
              </div>
              <div class="stakeholder-contact">
                <span class="contact-item">
                  <div class="skeleton-icon" />
                  <div class="skeleton-line skeleton-contact" />
                </span>
                <span class="contact-item">
                  <div class="skeleton-icon" />
                  <div
                    class="skeleton-line skeleton-contact skeleton-contact--wide"
                  />
                </span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style scoped>
@keyframes shimmer {
  0% {
    background-position: -400px 0;
  }
  100% {
    background-position: 400px 0;
  }
}

.organisations-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
  align-content: start;
  align-items: start;
}

.skeleton-card .card-header {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.skeleton-header {
  padding: 0.75rem 1rem;
  align-items: center;
}

.skeleton-line {
  border-radius: 4px;
  background: linear-gradient(90deg, #ebebeb 25%, #f5f5f5 50%, #ebebeb 75%);
  background-size: 800px 100%;
  animation: shimmer 1.4s infinite linear;
}

.skeleton-title {
  height: 1rem;
  width: 12rem;
  margin: 0.25rem 0;
}

.stakeholder-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.stakeholder-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 1rem;
  border-bottom: 1px solid #f0f0f0;
}

.stakeholder-item:last-child {
  border-bottom: none;
}

.skeleton-avatar {
  flex-shrink: 0;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 50%;
  background: linear-gradient(90deg, #ebebeb 25%, #f5f5f5 50%, #ebebeb 75%);
  background-size: 800px 100%;
  animation: shimmer 1.4s infinite linear;
}

.stakeholder-info {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  min-width: 0;
  flex: 1;
}

.stakeholder-top {
  display: flex;
  align-items: center;
  gap: 0.35rem;
}

.skeleton-role {
  height: 0.85rem;
  width: 6rem;
}

.skeleton-name {
  height: 0.7rem;
  width: 5rem;
  margin-left: auto;
}

.stakeholder-contact {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: 0.1rem;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.skeleton-icon {
  flex-shrink: 0;
  width: 14px;
  height: 14px;
  border-radius: 3px;
  background: linear-gradient(90deg, #ebebeb 25%, #f5f5f5 50%, #ebebeb 75%);
  background-size: 800px 100%;
  animation: shimmer 1.4s infinite linear;
}

.skeleton-contact {
  height: 0.7rem;
  width: 4rem;
}

.skeleton-contact--wide {
  width: 8rem;
}
</style>
